import styles from "../../../../styles/beneficios/steps/BenefitTypeSelectStep.module.scss";

import classNames from "classnames/bind";
import { If } from "../../../components/control-statements";
import { Icon } from "../../../components/core/Icon";
import { Label } from "../../../components/Label";
import { Select } from "../../../components/Select";
import { useEffect, useState } from "react";
import { OlgaEnvironmentsAPI } from "../../../../providers/OlgaEnvironmentsAPI";
import { Hairline } from "../../../components/Hairline";
import { Checkbox } from "@components";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

const benefitTypes = {
  CASH_DISCOUNT: "CASH_DISCOUNT",
  PERCENTAGE_DISCOUNT: "PERCENTAGE_DISCOUNT",
  FREE_DELIVERY: "FREE_DELIVERY",
  CASHBACK: "CASHBACK",
  PRODUCT_DISCOUNT: "PRODUCT_DISCOUNT",
  PRODUCT_CASH_DISCOUNT: "PRODUCT_CASH_DISCOUNT",
};

export const BenefitSelectTypeStep = ({
  benefit,
  onChange,
  programByPoint,
}) => {
  const [folders, setFolders] = useState([]);

  const allowsTemplate = Environment.id === 51 || Environment.id === 66;

  useEffect(() => {
    loadFolders();
  }, []);

  const selectBenefit = (type) => {
    onChange({ ...benefit, type });
  };

  const selectFolder = (folder) => {
    onChange({ ...benefit, folder: folder === -1 ? null : folder });
  };

  const toggleTemplate = () => {
    const newValue = !benefit?.template;
    onChange({
      ...benefit,
      template: newValue,
      single_use: newValue ? 4 : null,
    });
  };

  const loadFolders = async () => {
    const environmentConfigurations = (
      await OlgaEnvironmentsAPI.getConfigurations()
    ).getData({});
    const couponFolders = environmentConfigurations?.coupon_folders || [];
    setFolders(couponFolders);
  };

  const folderOptions = folders.map((folder) => ({
    label: folder.name,
    value: folder.id,
  }));

  return (
    <>
      <div className={styles.box}>
        <Label>Determine o benefício</Label>

        <div className={styles.benefits}>
          <div
            className={css({
              option: true,
              active: benefit.type === benefitTypes.CASH_DISCOUNT,
            })}
            onClick={() => selectBenefit(benefitTypes.CASH_DISCOUNT)}
          >
            <Icon name="sack-dollar" light />
            <p>Desconto em R$</p>
          </div>

          <div
            className={css({
              option: true,
              active: benefit.type === benefitTypes.PERCENTAGE_DISCOUNT,
            })}
            onClick={() => selectBenefit(benefitTypes.PERCENTAGE_DISCOUNT)}
          >
            <Icon name="percent" light />
            <p>Desconto em %</p>
          </div>

          <div
            className={css({
              option: true,
              active: benefit.type === benefitTypes.FREE_DELIVERY,
            })}
            onClick={() => selectBenefit(benefitTypes.FREE_DELIVERY)}
          >
            <Icon name="motorcycle" light />
            <p>Entrega grátis</p>
          </div>

          <If cond={!programByPoint}>
            <div
              className={css({
                option: true,
                active: benefit.type === benefitTypes.CASHBACK,
              })}
              onClick={() => selectBenefit(benefitTypes.CASHBACK)}
            >
              <Icon name="hand-holding-dollar" light />
              <p>Cashback</p>
            </div>
          </If>

          <If cond={programByPoint}>
            <div
              className={css({
                option: true,
                active: benefit.type === benefitTypes.CASHBACK,
              })}
              onClick={() => selectBenefit(benefitTypes.CASHBACK)}
            >
              <Icon name="circle-1" light />
              <p>Pontos</p>
            </div>
          </If>

          <div
            className={css({
              option: true,
              active: benefit.type === benefitTypes.PRODUCT_DISCOUNT,
            })}
            onClick={() => selectBenefit(benefitTypes.PRODUCT_DISCOUNT)}
          >
            <Icon name="pot-food" light />

            <p>Desconto em produto</p>
          </div>

          {(Environment.id === 66 || Environment.id === 8) && (
            <div
              className={css({
                option: true,
                active: benefit.type === benefitTypes.PRODUCT_CASH_DISCOUNT,
              })}
              onClick={() => selectBenefit(benefitTypes.PRODUCT_CASH_DISCOUNT)}
            >
              <Icon name="pot-food" light />

              <p>Produto (desconto em R$)</p>
            </div>
          )}
        </div>
      </div>

      <div className={styles.box}>
        <Label text={"Deseja agrupar este benefício em uma pasta?"} />
        <Select
          placeholder="Selecione (Opcional)"
          className="w-100"
          value={benefit?.folder}
          options={folderOptions}
          onChange={(e) => selectFolder(e.target.value)}
        />
      </div>

      {allowsTemplate && (
        <div className={styles.box}>
          <Checkbox
            checked={benefit?.template}
            onChange={() => toggleTemplate()}
          >
            Utilizar como um modelo?
          </Checkbox>
        </div>
      )}
    </>
  );
};
